import {getDataWithPromise, getParamList, Globals, handleAjaxError, urlExplode} from "./BaseDataFns";

export const getChildAltProviders = ( child_id, flags, onComplete ) =>
{
    const paramList = getParamList( flags, '?') ;

    const url = Globals.APIFolder + urlExplode ( '/children/{child_id}/altproviders', {child_id: child_id} ) + paramList;

    getDataWithPromise (url, 'GET', {})
       .then (response =>
       {
           onComplete (response) ;
       })
       .catch( (jqXHR, textStatus, error) =>
       {
           handleAjaxError( jqXHR, textStatus, error) ;
       });
}

export const getChildAltProviderDetails = ( child_id, cap_id, flags, onComplete ) =>
{
    const paramList = getParamList( flags, '?') ;

    const url = Globals.APIFolder + urlExplode ( '/children/{child_id}/altproviders/{cap_id}', {child_id: child_id, cap_id: cap_id } ) + paramList;

    getDataWithPromise (url, 'GET', {})
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const updatePlacementDetailsForChild = ( child_id, cap_id, data, onComplete ) =>
{
    const url = Globals.APIFolder + urlExplode ( '/children/{child_id}/altproviders/{cap_id}', {child_id: child_id, cap_id: cap_id } ) ;

    getDataWithPromise (url, 'PUT', data )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const endPlacementDetailsForChild = ( child_id, cap_id, data, onComplete ) =>
{
    const url = Globals.APIFolder + urlExplode ( '/children/{child_id}/altproviders/{cap_id}', {child_id: child_id, cap_id: cap_id } ) ;

    getDataWithPromise (url, 'DELETE', data )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}
export const createPlacementForChild = ( child_id, data, onComplete ) =>
{
    const url = Globals.APIFolder + urlExplode ( '/children/{child_id}/altproviders', {child_id: child_id} ) ;

    getDataWithPromise (url, 'POST', data )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}
